// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleTwoToneSvg from "@fishx/icons-svg/es/asn/PoundCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleTwoToneSvg
  }));
};

PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
export default React.forwardRef(PoundCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PoundCircleTwoTone.js
// module id = 3831
// module chunks = 0